import React from 'react';

import Select from '../Select';

const data = [
    {value: 1, label: "档案目录"},
    {value: 2, label: "档案文件"}
];

const DictFrom = (props) => (
    <Select name="dictFrom" label="作用范围" data={data} {...props} ></Select>
);

export default DictFrom;